<template>
  <div class="border-bottom py-2">
    <div class="d-flex align-items-center">
      <h5 class="mb-0 flex-grow-1 text-capitalize">{{ item.organ_name }}</h5>
      <b-dropdown variant="link" no-caret menu-class="mobile-menu">
        <template #button-content>
          <b-icon icon="three-dots" class="font-size-16"></b-icon>
        </template>
        <contacts :hospital="item"></contacts>
        <b-dropdown-item-button @click="$emit('open')">
          {{ isView ? "View" : "Edit" }}
        </b-dropdown-item-button>
        <b-dropdown-item-button v-if="isDeleteAble" @click="$emit('remove')"
          >Delete</b-dropdown-item-button
        >
        <b-dropdown-item-button v-if="isApprovable" @click="$emit('approve')"
          >Approve</b-dropdown-item-button
        >
        <b-dropdown-item-button v-if="isPayment" @click="$emit('payment')"
          >Pay Now</b-dropdown-item-button
        >
      </b-dropdown>
    </div>
    <p class="mb-0 text-capitalize">
      {{ item.hospital_name }}
    </p>
    <div class="d-flex">
      {{ item.certificate_number || "-" }}
      <div class="flex-grow-1"></div>
    </div>
    <p class="mb-0 font-size-11">{{ item.expiry_date_format }}</p>
    <div class="d-flex align-center">
      <template v-if="isUpdateView">
        <div
          v-if="isUpdate"
          class="badge bg-danger font-size-13"
          @click="$emit('open')"
        >
          Update Details
        </div>
        <div class="badge bg-secondary font-size-13" v-else>
          Details Updated
        </div>
      </template>
      <div class="flex-grow-1"></div>
      <div :class="getBg(item)">
        {{ getStatus(item) }}
      </div>
    </div>
  </div>
</template>

<script>
import { STATUS } from "../../assets/constants/hospital.contants";
import Contacts from "./list/Contacts.vue";

export default {
  props: {
    item: {},
    isView: {},
    isPayment: {},
    isApprovable: {},
    isDeleteAble: {},
    isUpdate: {},
    isUpdateView: {},
  },
  components: { Contacts },
  methods: {
    getStatus({ status }) {
      return STATUS[status] || "";
    },
    getBg(item) {
      let val = this.getStatus(item);
      switch (val) {
        case "Active":
          return "badge bg-success font-size-13";
        case "Pending Approval":
          return "badge bg-warning font-size-13";
        case "Inactive":
          return "badge bg-danger font-size-13";
        case "Deleted":
          return "badge bg-danger font-size-13";
        default:
          return "badge bg-light font-size-13";
      }
    },
  },
};
</script>

<style>
.mobile-menu {
  right: 0px !important;
  left: unset !important;
}
</style>
